(function ($) {$(function(){
    window._currentViewLayout = 'desktop';
    setTimeout(updateDirectosColumnsWidth, 500);
    setTimeout(calcAppHeight, 500);
    // setTimeout(mainMenuItemSize, 1000);
    calcAppHeight();
    setPreviewPlayerSize();
    mobileAndDesktopGrid()
});}(_jQ3));

_jQ3(window).resize(updateDirectosColumnsWidth);
_jQ3(window).resize(calcAppHeight);
_jQ3(window).resize(setPreviewPlayerSize);
_jQ3(window).resize(updateDirectorPMVideoSize);
_jQ3(window).resize(mobileAndDesktopGrid);
// window.addEventListener('resize', mainMenuItemSize);

const sortNewsItemsMobile = function(a, b) {
    if (a.id == 'grid-sizer' || b.id == 'grid-sizer') {
        return 1;
    }
    return +a.dataset.mobileOrder - +b.dataset.mobileOrder;
}
const sortNewsItemsDesktop = function(a, b) {
    if (a.id == 'grid-sizer' || b.id == 'grid-sizer') {
        return 1;
    }
    return +a.dataset.desktopOrder - +b.dataset.desktopOrder;
}

function calcAppHeight() {
    var doc = _jQ3('html')
    var appmenu = _jQ3('.appmenu')
    doc.css('--app-height', `${window.innerHeight}px`)
    doc.css('--app-content-height', `${(window.innerHeight - 42)}px`)
}

function mainMenuItemSize() {
    const $ = _jQ3;
    $menuItems = $('.menu-content ul li')
    $menuItems.each(function (){
        $el = $(this);
        $el.css('--mw', Math.ceil($el.outerWidth()) + 5);
    })
}
function updateDirectosColumnsWidth(){
    const $ = _jQ3;
    const colContainer = $('.director-cols-container').outerWidth()
    const $colContainerSize = Math.floor((colContainer / 2) - 14);
    const $columns = $('ul.director-list');
    $columns.each(function(){
        const $this = $(this);
        $this.css('--mw', $colContainerSize);
    });
}

function setPreviewPlayerSize() {
    const $ = _jQ3;
    const $player = $('#preview-player');
    if ($player.length > 0) {
        $player.css('--pw', $player.outerWidth());
        $player.css('--ph', $player.outerHeight());
    }
}

function updateDirectorPMVideoSize(){
    const $ = _jQ3;
    const $video = $('.preview.pm video')
    if ($video.length > 0) {
        const windowWidth = $(window).innerWidth()
        const windowHeight = $(window).innerHeight()
        const videoWidth = $video.outerWidth()
        const videoHeight = $video.outerHeight()
        if(videoWidth < windowWidth){
            $video.css('width','100%'); $video.css('height','auto');
        }
        if(videoHeight < windowHeight){
            $video.css('width','auto'); $video.css('height','var(--app-height)');
        }
    }
}

function mobileAndDesktopGrid(){
    const width = 993;
    if (window.innerWidth < width && window._currentViewLayout == 'desktop') {
        window._currentViewLayout = 'mobile';
        const $grid = _jQ3('#mgrid');
        let items = $grid.children();
        items.sort(sortNewsItemsMobile)
        $grid.html(items);
        window.$grid.masonry('destroy');
        window.$grid = _jQ3('.mgrid').masonry({
            itemSelector: '.grid-item',
            columnWidth: '.grid-sizer',
            transitionDuration: '0.2s',
            percentPosition: true,
            gutter: 5,
            // horizontalOrder: true
        });
    } 
    if (window.innerWidth > width && window._currentViewLayout == 'mobile') {
        window._currentViewLayout = 'desktop';
        const $grid = _jQ3('#mgrid');
        let items = $grid.children();
        items.sort(sortNewsItemsDesktop)
        $grid.html(items);
        window.$grid.masonry('destroy');
        window.$grid = _jQ3('.mgrid').masonry({
            itemSelector: '.grid-item',
            columnWidth: '.grid-sizer',
            transitionDuration: '0.2s',
            percentPosition: true,
            gutter: 5,
            // horizontalOrder: true
        });
    }
}

window.updateDirectorPMVideoSize = updateDirectorPMVideoSize;
window.mobileAndDesktopGrid = mobileAndDesktopGrid;